const DEFAULT_MAX_RECORDING_SECONDS = 7200

export function getMaxRecordingDurationSeconds(): number {
	const raw = window.RUNTIME_CONFIG?.MAX_RECORDING_DURATION_SECONDS
	if (typeof raw === 'number' && Number.isFinite(raw) && raw > 0) {
		return Math.floor(raw)
	}
	if (typeof raw === 'string' && raw.trim() !== '') {
		const n = Number.parseInt(raw, 10)
		if (Number.isFinite(n) && n > 0) {
			return n
		}
	}
	return DEFAULT_MAX_RECORDING_SECONDS
}
